import Cookies from 'js-cookie'
import store from '@state/store'

const cookieName = 'id_parceiro'
const conf = { domain: process.env.VUE_APP_COOKIE_DOMAIN }

export default {
  saveId(id) {
    Cookies.set(cookieName, id, conf)
  },
  getId() {
    return (
      Cookies.get(cookieName) ||
      (!!store.state.currentUser ? store.state.currentUser.idParceiro : null)
    )
  },
}
